<div class="form-container">
    <h2>Creación de Contrato Individual</h2>

    <!-- Contrato -->
    <div *ngIf="currentStep === 1" class="step">
        <div class="section">
            <h3 class="section-title">Contrato</h3>
            <div class="form-row">
                <div class="form-group">
                    <label for="contractNumber">Número de Contrato</label>
                    <input id="contractNumber" type="number" [(ngModel)]="contractDetails.contractNumber"
                        [ngModelOptions]="{standalone: true}" placeholder="Solo números" />
                </div>
                <div class="form-group">
                    <label for="contractDate">Fecha del Contrato</label>
                    <input id="contractDate" type="date" [(ngModel)]="contractDetails.contractDate" [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="form-group">
                    <label for="contractType">Tipo de Contrato</label>
                    <input id="contractType" [(ngModel)]="contractDetails.contractType"
                        [ngModelOptions]="{standalone: true}" placeholder="Contrato de prestacion de servicios" />
                </div>
            </div>
        </div>

        <div class="section">
                <h3 class="section-title">Firmantes</h3>
                <div class="form-row">
                  <div class="section" *ngIf="availableSigners.length > 0">
                    <label class="form-label">Selecciona los firmantes</label>
                    <div class="signer-list">
                      <label *ngFor="let signer of availableSigners" class="signer-list-item">
                        {{ signer.firstName }} {{ signer.lastName }}
                        <input type="checkbox"
                               [checked]="selectedSigners.includes(signer.signerId)"
                               (change)="toggleSignerSelection(signer.signerId)" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

        <!-- Contratista -->
        <div class="section">
            <h3 class="section-title">Contratista</h3>
            <div class="form-group">
                <div class="checkbox-group">
                    <label>
                        <input type="radio" name="contractorType" value="natural" [(ngModel)]="contractorType"
                            [ngModelOptions]="{standalone: true}" />
                        Persona Natural
                    </label>
                    <label>
                        <input type="radio" name="contractorType" value="juridica" [(ngModel)]="contractorType"
                            [ngModelOptions]="{standalone: true}" />
                        Persona Jurídica
                    </label>
                </div>
            </div>

            <!-- Campos para Persona Natural -->
            <div *ngIf="contractorType === 'natural'">
                <div class="form-row">
                    <div class="form-group">
                        <label for="naturalName">Nombre</label>
                        <input id="naturalName" type="text" [(ngModel)]="naturalData.name"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre completo" />
                    </div>
                    <div class="form-group">
                        <label for="naturalIdType">Tipo de Identificacion</label>
                        <select id="naturalIdType" [(ngModel)]="naturalData.idType"
                            [ngModelOptions]="{standalone: true}">
                            <option value="CC">Cédula de ciudadanía</option>
                            <option value="CE">Cédula de extranjería</option>
                            <option value="PA">Pasaporte</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="naturalId">Número de Identificación</label>
                        <input id="naturalId" type="number" [(ngModel)]="naturalData.id"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="naturalPlace">Lugar de expedición</label>
                        <input id="naturalPlace" type="text" [(ngModel)]="naturalData.place"
                            [ngModelOptions]="{standalone: true}" placeholder="Ciudad" />
                    </div>
                    <div class="form-group">
                        <label for="naturalAddress">Domicilio</label>
                        <input id="naturalAddress" type="text" [(ngModel)]="naturalData.address"
                            [ngModelOptions]="{standalone: true}" placeholder="Dirección de residencia" />
                    </div>
                    <div class="form-group">
                        <label for="naturalCity">Ciudad</label>
                        <input id="naturalCity" type="text" [(ngModel)]="naturalData.city"
                            [ngModelOptions]="{standalone: true}" placeholder="Ciudad de residencia" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="naturalDepartment">Departamento</label>
                        <input id="naturalDepartment" type="text" [(ngModel)]="naturalData.department"
                            [ngModelOptions]="{standalone: true}" placeholder="Departamento de residencia" />
                    </div>
                    <div class="form-group">
                        <label for="naturalEmail">Correo electrónico</label>
                        <input id="naturalEmail" type="email" [(ngModel)]="naturalData.email"
                            [ngModelOptions]="{standalone: true}" placeholder="ejemplo@correo.com" />
                    </div>
                    <div class="form-group">
                        <label for="naturalPhone">Teléfono</label>
                        <input id="naturalPhone" type="number" [(ngModel)]="naturalData.phone"
                            [ngModelOptions]="{standalone: true}" placeholder="Número telefónico" />
                    </div>
                </div>
            </div>

            <!-- Campos para Persona Jurídica -->
            <div *ngIf="contractorType === 'juridica'">
                <div class="form-row">
                    <div class="form-group">
                        <label for="juridicaName">Razón Social</label>
                        <input id="juridicaName" type="text" [(ngModel)]="juridicaData.juridicaName"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre de la empresa" required />
                    </div>
                    <div class="form-group">
                        <label for="juridicaIdType">Tipo de Identificacion</label>
                        <select id="juridicaIdType" [(ngModel)]="juridicaData.juridicaIdType"
                            [ngModelOptions]="{standalone: true}">
                            <option value="CC">Cédula de ciudadanía</option>
                            <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="juridicaNit">Numero de Identificacion</label>
                        <input id="juridicaNit" type="number" [(ngModel)]="juridicaData.nit"
                            [ngModelOptions]="{standalone: true}" placeholder="Número de identificación tributaria"
                            required />
                    </div>                
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="juridicaAddress">Dirección Física</label>
                        <input id="juridicaAddress" type="text" [(ngModel)]="juridicaData.address"
                            [ngModelOptions]="{standalone: true}" placeholder="Dirección comercial" required />
                    </div>
                    <div class="form-group">
                        <label for="juridicaCity">Ciudad</label>
                        <input id="juridicaCity" type="text" [(ngModel)]="juridicaData.city"
                            [ngModelOptions]="{standalone: true}" placeholder="Ciudad" required />
                    </div>
                    <div class="form-group">
                        <label for="juridicaDept">Departamento</label>
                        <input id="juridicaDept" type="text" [(ngModel)]="juridicaData.department"
                            [ngModelOptions]="{standalone: true}" placeholder="Departamento" required />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="juridicaEmail">Correo Electrónico</label>
                        <input id="juridicaEmail" type="email" [(ngModel)]="juridicaData.email"
                            [ngModelOptions]="{standalone: true}" placeholder="ejemplo@empresa.com" required />
                    </div>
                    <div class="form-group">
                        <label for="juridicaRep">Representante Legal</label>
                        <input id="juridicaRep" type="text" [(ngModel)]="juridicaData.representative"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre completo" required />
                    </div>
                    <div class="form-group">
                        <label for="juridicaRep">Numero de Identificacion</label>
                        <input id="juridicaRep" type="number" [(ngModel)]="juridicaData.representativeId"
                            [ngModelOptions]="{standalone: true}" placeholder="123456789" required />
                    </div>
                </div>
            </div>                                    

            <!-- Botón siguiente -->
            <div class="form-actions">
                <button type="button" class="next" (click)="saveAsDraft()">Guardar Formulario</button>
                <button type="button" class="next" (click)="goToNextStep()">Siguiente</button>
            </div>
        </div>
    </div>

    <!-- Paso 2 -->
    <div *ngIf="currentStep === 2" class="step">
        <form>
            <!-- Sección: Objeto -->
            <div class="section">
                <h3 class="section-title">Objeto</h3>
                <div class="form-group">
                    <label for="objectDescription">Descripción de Objeto</label>
                    <textarea id="objectDescription" rows="4" [(ngModel)]="contractDetails.objectDescription"
                        [ngModelOptions]="{standalone: true}" placeholder="Describe el objeto del contrato"></textarea>
                </div>
            </div>

            <!-- Sección: Contabilidad -->
            <div class="section">
                <h3 class="section-title">Finanzas</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="contractDuration">Duración del Contrato</label>
                        <input id="contractDuration" type="text" [(ngModel)]="contractDetails.contractDuration"
                            [ngModelOptions]="{standalone: true}" placeholder="1 Año"/>
                    </div>
                    <div class="form-group">
                        <label for="totalValue">Valor Total del Contrato</label>
                        <input id="totalValue" type="number" [(ngModel)]="contractDetails.totalValue"
                            [ngModelOptions]="{standalone: true}" placeholder="0000000"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="installments">Número de Cuotas</label>
                        <input id="installments" type="number" [(ngModel)]="contractDetails.installments" min="1"
                            [ngModelOptions]="{standalone: true}" placeholder="1"/>
                    </div>
                    <div class="form-group">
                        <label for="workType">Tipo de Destajo</label>
                        <input id="workType" type="text" [(ngModel)]="contractDetails.workType"
                            [ngModelOptions]="{standalone: true}" placeholder="Contado"/>
                    </div>
                    <div class="form-group">
                        <label for="fundingSource">Soporte de Pago</label>
                        <select id="fundingSource" [(ngModel)]="contractDetails.fundingSource"
                            [ngModelOptions]="{standalone: true}">
                            <option value="Factura">Factura</option>
                            <option value="Planilla">Planilla</option>
                            <option value="Informe de Actividad">Informe de Actividad</option>
                            <option value="Certificado de Cumplimiento">Certificado de Cumplimiento</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Sección: CDP -->
            <div class="section">
                <h3 class="section-title">CDP</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="cdpNumber">Número CDP</label>
                        <input id="cdpNumber" type="number" [(ngModel)]="contractDetails.cdpNumber"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="form-group">
                        <label for="cdpDate">Fecha</label>
                        <input id="cdpDate" type="date" [(ngModel)]="contractDetails.cdpDate"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
            </div>

            <!-- Sección: Obligaciones -->
            <div class="section">
                <h3 class="section-title">Obligaciones</h3>
                <div class="form-group">
                    <label for="contractorObligations">Obligaciones del contratante</label>
                    <textarea id="contractorObligations" rows="4" [(ngModel)]="contractDetails.contractorObligations"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Describe las obligaciones del contratante"></textarea>
                </div>
                <div class="form-group">
                    <label for="contractorDuties">Obligaciones del contratista</label>
                    <textarea id="contractorDuties" rows="4" [(ngModel)]="contractDetails.contractorDuties"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="Describe las obligaciones del contratista"></textarea>
                </div>
            </div>

            <!-- Contenedor de los botones -->
            <div class="form-actions">
                <button type="button" class="previous" (click)="goToPreviousStep()">Anterior</button>
                <button type="button" class="next" (click)="saveAsDraft()">Guardar Formulario</button>
                <button type="button" class="next" (click)="goToNextStep()">Siguiente</button>
            </div>

        </form>
    </div>

    <!-- Paso 3 -->
    <div *ngIf="currentStep === 3" class="step">
        <form>

            <!-- Sección: Garantías -->
            <div class="section">
                <h3 class="section-title">Garantías</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="guaranteeType">Tipo de garantía</label>
                        <input id="guaranteeType" type="text" [(ngModel)]="guarantees.guaranteeType"
                            [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="form-group">
                        <label for="insurer">Asegurador</label>
                        <input id="insurer" type="text" [(ngModel)]="guarantees.insurer"
                            [ngModelOptions]="{standalone: true}" placeholder="Nombre del asegurador" />
                    </div>
                    <div class="form-group">
                        <label for="guaranteeAmount">Monto (%)</label>
                        <input id="guaranteeAmount" type="number" [(ngModel)]="guarantees.guaranteeAmount"
                            [ngModelOptions]="{standalone: true}" min="0" max="100"
                            placeholder="Ingrese el porcentaje" />
                    </div>
                </div>
            </div>

            <!-- Sección: Penalidad -->
            <div class="section">
                <h3 class="section-title">Penalidad</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="penaltyAmount">Monto (%)</label>
                        <input id="penaltyAmount" type="number" [(ngModel)]="guarantees.penaltyAmount"
                            [ngModelOptions]="{standalone: true}" min="0" max="100"
                            placeholder="Ingrese el porcentaje" />
                    </div>
                    <div class="form-group">
                        <label for="penaltyBase">Base</label>
                        <input id="penaltyBase" type="text" [(ngModel)]="guarantees.penaltyBase"
                            [ngModelOptions]="{standalone: true}" placeholder="Base de la penalidad" />
                    </div>
                </div>
            </div>

            <!-- Sección: Multa -->
            <div class="section">
                <h3 class="section-title">Multa</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="fineAmount">Monto (%)</label>
                        <input id="fineAmount" type="number" [(ngModel)]="guarantees.fineAmount"
                            [ngModelOptions]="{standalone: true}" min="0" max="100"
                            placeholder="Ingrese el porcentaje" />
                    </div>
                    <div class="form-group">
                        <label for="fineBase">Base</label>
                        <input id="fineBase" type="text" [(ngModel)]="guarantees.fineBase"
                            [ngModelOptions]="{standalone: true}" placeholder="Base de la multa" />
                    </div>
                </div>
            </div>


            <!-- Contenedor de los botones -->
            <div class="form-actions">
                <button type="button" class="previous" (click)="goToPreviousStep()">Anterior</button>
                <button type="button" class="next" (click)="saveAsDraft()">Guardar Formulario</button>
                <button type="button" class="next" (click)="generateDocument()">Generar Documento</button>
            </div>

        </form>
    </div>
</div>